let ready = false;

export function isDynamicRoutesReady() {
  return ready;
}

export function markDynamicRoutesReady() {
  ready = true;
}

export function resetDynamicRoutes() {
  ready = false;
}
